import { RETIRED_WORD_SLOT, type QuizKitCopy } from '@peach/types/quizzes/generated-quiz.dto.js';

export function kitDoor(username: string): string {
  return `meetmy.io/${username}`;
}

/** The last slide's line (`QuizKitCopy`). */
export type KitCopy = QuizKitCopy;

/**
 * What a quiz without a kit says — hand-written ones, and every quiz before
 * 2026-09-13. English whatever the quiz's language: those were not worth a backfill.
 */
export const STOCK_KIT_COPY: KitCopy = {
  door: 'Take the full quiz and see your score: link in bio',
};

/**
 * The generator's line when the quiz has one, else the stock line. A door from the comment-word
 * days (2026-10-01 to 2026-10-09) asks for a word nothing answers any more, so it takes the stock line.
 */
export function kitCopyOf(kit: QuizKitCopy | undefined): KitCopy {
  if (!kit || kit.door.includes(RETIRED_WORD_SLOT)) return STOCK_KIT_COPY;
  return { door: kit.door };
}
